<template>
<CRow class="mt-3">
    <CCol col="12" sm="12" md="10" lg="7" xl="7" class="mx-auto alert alert-warning">
        <p>کاربر محترم، در میزان مبلغ شارژ کیف پول دقت داشته باشید پس از شارژ کیف پول امکان عودت وجه وجود ندارد.</p>
    </CCol>

    <CCol col="12" sm="12" md="10" lg="7" xl="7" class="mx-auto">
        <span class="d-block text-left">موجودی:‌ <strong class="ltr d-inline-block">{{ $numberWithCommas($currentUser().balance) }}</strong> {{ $t('rial') }}</span>
        <div class="p-2 b-a-2 bg-white">
            <div v-if="!hasCallbackResponse">
                <ChargeForm v-if="!loading" ref="chargeForm" :submit="charge" :transaction="transaction" />
                <p v-if="!implementScript && user.balance < 30000000" class="alert alert-warning text-center d-block mt-4">
                    مبلغ 10,000,000 میلیون ریال جهت پیاده‌سازی اسکریپت توسط افیلی به صورت حساب شما اضافه شده است.
                </p>
            </div>
            <div v-else>
                <Loading />

                <FaIcon :icon="icon.icon" :class="icon.class" />
                <p class="text-center mt-4 payment-message">{{ message }}</p>
                <p v-if="result.status === 'success'" class="text-center text-muted text-small">
                    {{ $t('transaction.your_account_charged', {amount: result.transaction.amount}) }}
                </p>
                <div class="text-center">
                    <CButton @click="$router.push({name: 'setup.steps.charge_account'})" color="outline-affili-cerise">
                        بازگشت به فرم پرداخت
                    </CButton>
                    <CButton @click="verifyPurchace" color="outline-primary" class="mfs-2">
                        بررسی مجدد وضعیت پرداخت
                    </CButton>
                </div>
            </div>

            <CRow>
                <CCol col="12" class="b-t-1 pt-2 mt-3">
                    <CButton :disabled="checkChargeAccount" @click="nxt" type="button"  color="primary" class="px-4 float-right">{{ $t('btn.next_step') }}</CButton>
                    <CButton type="button" @click="prev" color="outline-primary" class="px-4 ml-auto float-left">{{ $t('btn.prev_step') }}</CButton>
                </CCol>
            </CRow>
        </div>

    </CCol>
</CRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ChargeForm } from '@/views/transactions/partials'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'ChargeAccount',

    components: {
        ChargeForm
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.loading = true
            vm.fetchStores({
                no_paginate: true
            }).then(() => {
                vm.testConversion(vm.store.id).then(result => {
                    vm.implementScript = result.data.amount && result.data.external_id ? true : false
                    let userBalance = parseInt(vm.user.balance)

                    if (!vm.implementScript && userBalance < 30000000) {
                        vm.transaction.amount = 30000000 - userBalance
                    }
                    vm.loading = false
                })
            })
        })
    },

    data() {
        return {
            loading: false,
            implementScript: true,
            transaction: {
                amount: 20000000,
                coupon_code: null,
            },
            result: {
                status: 'unkown',
                transaction: {
                    id: 0,
                    amount: 0,
                    coupon_code: null,
                },
                is_first_charge: false,
            },
        }
    },

    // watch: {
    //     'result.status'(value) {
    //         if(value === 'success' && this.result.is_first_charge) {
    //             this.$affiliJs.conversion(this.result.transaction.id, this.result.transaction.amount, 'chargeAccount')
    //         }
    //     }
    // },

    computed: {
        ...mapGetters({
            store: 'store/firstStore'
        }),
        hasCallbackResponse() {
            return this.$route.query.Authority && this.$route.query.Status
            && this.$route.query.transaction_id
        },
        user() {
            return this.$currentUser()
        },
        icon() {
            const icons = {
                OK: {
                    icon: 'check-circle',
                    class: 'font-5xl d-block mx-auto text-success'
                },
                NOK: {
                    icon: 'times-circle',
                    class: 'font-5xl d-block mx-auto text-danger'
                },
                duplicate: {
                    icon: 'exclamation-circle',
                    class: 'font-5xl d-block mx-auto text-affili-coral'
                },
                unkown: {
                    icon: 'question-circle',
                    class: 'font-5xl d-block mx-auto text-black-50'
                }
            }

            return icons[this.result.status]
        },
        message() {
            const messages = {
                OK: this.$t('transaction.success_payment'),
                NOK: this.$t('transaction.fail_payment'),
                duplicate: this.$t('transaction.duplicate_payment'),
                unkown: this.$t('transaction.unkown_payment'),
            }

            return messages[this.result.status]
        },
        checkChargeAccount() {
            return !(this.implementScript ? this.user.balance >= 15000000 : this.user.balance >= 20000000)
        }
    },

    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
            chargeAccount: 'transaction/charge',
            verify: 'transaction/verify',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            testConversion: 'store/testConversion',
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
            fetchCurrentUser: 'user/fetchCurrent'
        }),
        charge() {
            this.setShowLoading()
            this.resetMsg()

            const data = {
                amount: this.transaction.amount,
                callback_address: this.$url('setup/steps/step=charge-account'),
                coupon_code: this.transaction.coupon_code,
            }

            this.chargeAccount(data).then(result => {
                this.$redirect(result.redirect_to)
            }).catch(result => {
                if(result.data) {
                    this.$refs.chargeForm.$refs.form.setErrors(result.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
        prev() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.IMPLEMENT_SCRIPT).then(() => {
                this.setShowLoading(false)
            })
        },
        nxt() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.PENDING_TO_ACTIVE).then(() => {
                this.setShowLoading(false)
            })
        },
        verifyPurchace() {
            this.setShowLoading()
            this.verify(this.$route.query).then(result => {
                this.result = result.data
                if (result.data.status === 'OK') {
                    this.fetchCurrentUser()
                }
                this.setShowLoading(false)
            })
        }
    },

    mounted() {
        if (this.hasCallbackResponse) {
            this.verifyPurchace()
        }
    },
}
</script>